import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth } from "firebase/auth";
import { CURRENT_CLUB_ID } from "./constants";

export type AuditAction = "create" | "update" | "delete";
export type AuditEntity = "rank" | "referee" | "news" | "team" | "leader" | "competition";

interface AuditLogData {
  action: AuditAction;
  entity: AuditEntity;
  entityId: string;
  entityName?: string;
  clubId: string;
  userEmail: string;
  userId: string;
  changes?: any;
  timestamp: any;
}

/**
 * Create an audit log entry for admin actions
 * @param action - The action performed (create, update, delete)
 * @param entity - The entity type (rank, referee, news, team, leader, competition)
 * @param entityId - The ID of the entity
 * @param entityName - Optional name/title of the entity for easier identification
 * @param changes - Optional object containing the changes made
 */
export const createAuditLog = async (
  action: AuditAction,
  entity: AuditEntity,
  entityId: string,
  entityName?: string,
  changes?: any
): Promise<void> => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      console.error("No authenticated user found for audit log");
      return;
    }

    const auditLogData: AuditLogData = {
      action,
      entity,
      entityId,
      entityName,
      clubId: CURRENT_CLUB_ID,
      userEmail: user.email || "unknown",
      userId: user.uid,
      changes,
      timestamp: serverTimestamp(),
    };

    await addDoc(collection(db, "auditLogs"), auditLogData);
  } catch (error) {
    console.error("Error creating audit log:", error);
    // Don't throw error to prevent disrupting the main operation
  }
};
